jQuery(function($){
    console.log('file loaded');
    

     setTimeout(function(){
        //scrollabel region fix
        jQuery('scroll-carousel').each(function(){
            jQuery(this).attr('tabindex','0');
        });       
       
        //landmarks
        var carCnt = 1;
        jQuery('[aria-label="Carousel"]').each(function(){
          jQuery(this).attr('aria-label','Carousel #'+carCnt);
          carCnt++;
        });
        jQuery('[aria-label="Open Form"]').each(function(){
          jQuery(this).attr('role','region');
        });

        //hidden elements being focusable
        jQuery('.carousel-prev').each(function(){
          var curHidden = String(jQuery(this).attr('aria-hidden'));
          if(jQuery(this).hasClass('is-hidden')){
            jQuery(this).attr('tabindex','-1');
          }
          if(curHidden === 'true'){
            jQuery(this).attr('tabindex','-1');
          }

        });

     //Images
     //begin updates to alternate text, title, and aria-label if needed only
     var imgCnt = 1;
     jQuery('img').each(function () {
         var curAlt = jQuery(this).attr('alt');
         var curTitle = jQuery(this).attr('title');
         var curAriaLbl = jQuery(this).attr('aria-label');
         var curImgPrnts = jQuery(this).parents().map(function () {
             return this.tagName;
         })
             .get()
             .join(', ');
 
         //no alt text or empty alt text or undefined
         if (!curAlt || curAlt === '' || curAlt === 'undefined') {
             jQuery(this).attr('alt', ''); //decorative	
             if (curImgPrnts.includes('A,') || curImgPrnts.includes(' A ')) {
                 jQuery(this).attr('alt', 'Image link #' + imgCnt);
				 if (!curTitle || curTitle === '' || curTitle === 'undefined') {
 
					} else {
						jQuery(this).attr('title', curTitle);
					}
				 if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
                     if (!curTitle || curTitle === '' || curTitle === 'undefined') {
 
					} else {
						jQuery(this).attr('aria-label', curTitle);
					}
                 } else {
                     /*add it back in*/
                     jQuery(this).attr('aria-label', curAriaLbl);
                 }
             } else {
                 //if empty then should not contain title or aria-label
                 jQuery(this).removeAttr('aria-label');
                 jQuery(this).removeAttr('title');
             }
 
         } else {
             //alt present so we should leave alt alone
             jQuery(this).attr('alt', curAlt);
             //if title present add an aria-label as well
             if (!curTitle || curTitle === '' || curTitle === 'undefined') {
 
             }
             else {
                 /*Add title back in*/
                 jQuery(this).attr('title', curTitle);
                 //first check to make sure it doesn't already have aria-label
                 if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
                     jQuery(this).attr('aria-label', curTitle);
                 } else {
                     /*add it back in*/
                     jQuery(this).attr('aria-label', curAriaLbl);
                 }
             }
 
         }
         imgCnt++;
     });
     jQuery('a[href]').each(function(){
      var curHtml = String(jQuery(this).html());
      if(!curHtml || curHtml === ''){
        jQuery(this).remove();
      }
    });
     //end updates to alternate text, title, and aria-label if needed only

     //cart page
     jQuery('.pw-cashback-header-container').each(function(){
      jQuery(this).attr('role','region').attr('aria-label','Expand Benefits Button Container');
      jQuery(this).find('.pw-route-protection').attr('role','region');
    });
        setTimeout(function(){
        jQuery('.carousel-next').each(function(){
          var curHidden = String(jQuery(this).attr('aria-hidden'));
          if(jQuery(this).hasClass('is-hidden')){
            jQuery(this).attr('tabindex','-1');
          }
          
          if(curHidden === 'true'){
            jQuery(this).attr('tabindex','-1');
            console.log('aria-hidden ='+curHidden);
          }
        });


        jQuery('.variant-select').each(function(){
          jQuery(this).find('select').attr('aria-label','Variant Selector');
        });
        var selectCnt = 1;
        jQuery('select').each(function(){
          var curAria = String(jQuery(this).attr('aria-label'));
          var curId = String(jQuery(this).attr('id'));
          if(!curId || curId === '' || curId === 'undefined'){
            jQuery(this).attr('id','select_'+selectCnt);
          }
          if(!curAria || curAria === '' || curAria === 'undefined'){
            jQuery(this).attr('aria-label','Select Options #'+selectCnt);
          }
          selectCnt++;
        });

        jQuery('[data-discounted-price-value]').each(function(){
          jQuery(this).append('<span class="sr-only"> (Discounted Price) </span>');
        });
        jQuery('[data-regular-price-value]').each(function(){
          jQuery(this).append('<span class="sr-only"> (Original Price  - Struck through) </span>');
        });
        
        },1000);       
           
    }, 1800);

 setTimeout(function(){
        //nested controls within menu
        jQuery('.header__nav').each(function(){
          jQuery(this).find('.menu').each(function(){
            var detCnt = 1;
            jQuery(this).find('details').each(function(){
              var newSubMenuItem = '';
              jQuery(this).attr('epic-index',detCnt);
              jQuery(this).find('summary').each(function(){
                jQuery(this).find('.menu-item').each(function(){
                  jQuery(this).removeAttr('aria-hidden');
                  jQuery(this).find('span').removeAttr('aria-hidden');
                  var itemHref = String(jQuery(this).attr('href'));
                  var itemTxt = String(jQuery(this).text());
                  itemTxt = jQuery.trim(itemTxt);
                  if(detCnt === 1){
                    jQuery(this).find('span').html('Shop');
                  } else if(detCnt >= 2 && detCnt <= 4){
                    itemTxt = 'All '+itemTxt;
                  }
                  newSubMenuItem = '<a class="dropdown-menu-item" href="'+itemHref+'">'+itemTxt+'</a>';
                  var el = jQuery(this),
                    html = el.html(),
                   attrs = {
                                     "id": el.attr('id'),
                                  "class": el.attr('class'),
                                  "style": el.attr('style'),
                      "data-acsb-tooltip": el.attr('data-acsb-tooltip')
                            };
                  //console.log('Replacing ' + el.prop('tagName') + ', classes: ' + attrs.classes);
                  el.replaceWith(jQuery('<div></div>').html(html).attr(attrs));
                });
              });
              if(!newSubMenuItem || newSubMenuItem === '' || newSubMenuItem === 'undefined'){}else{
                jQuery(this).find('.header-dropdown').each(function(){
                  if(detCnt !== 5){
                    jQuery(this).prepend(newSubMenuItem);
                  }
                });
              }
              if(detCnt === 5){
                var topItem = 0;
                jQuery(this).find('.header-dropdown').each(function(){
                  jQuery(this).find('a').each(function(){
                    if(topItem === 0){
                      jQuery(this).find('span').html('About NESTOUT');
                    }
                    topItem++;
                  });
                });
              
              }
              $(this).find('a[href]').each(function(){
                $(this).on('keydown',function(e){
                  if(e.key === 'Escape'){
                    $(this).parent().parent().find('summary').click().focus();
                  }
                });
              });

              detCnt++;
            });
          });
        });  
        
        //fix role
        jQuery('.yotpo-widget-clear').each(function(){
          jQuery(this).attr('role','region');
          var curAria = String(jQuery(this).attr('aria-labelledby'));
          if(curAria !== ''){
            jQuery(this).attr('aria-label',curAria);
            jQuery(this).removeAttr('aria-labelledby');
          }
        });
        //
        //jQuery('#buttons-container').attr('role','region');
        jQuery('.yotpo-bottom-line-stars').each(function(){
          jQuery(this).attr('role','region');
        });
        jQuery('.yotpo-main-layout').each(function(){
          jQuery(this).attr('role','region');
        });
       
        //sticky-add-to-cart
        var stickyCnt = 1;
        jQuery('.sticky-add-to-cart-wrapper').each(function(){
          jQuery(this).addClass('epic-modify-wrapper');
          jQuery(this).find('.product-thumbnail').each(function(){
            jQuery(this).remove();
          });
          jQuery(this).find('.product-title').each(function(){
            jQuery(this).addClass('sr-only');
            jQuery(this).find('.heading').attr('id','title_'+stickyCnt);
          });
          jQuery(this).find('.button').each(function(){
            jQuery(this).addClass('epicOptBtn');
            jQuery(this).removeClass('whitespace-nowrap');
            jQuery(this).removeClass('button');
            jQuery(this).attr('aria-labelledby','title_'+stickyCnt);
            jQuery(this).find('span').addClass('sr-only');
            jQuery(this).append('<i aria-hidden="true" class="fa-solid fa-rectangle-list"></i>');
            jQuery(this).attr('title','Select Options');
          });
          stickyCnt++;
        });
         
        setTimeout(function(){
        //fix video related
        var custom_controls_1 = '<div class="video-container-1"><div class="custom-controls">'+
          ' <button class="video-controls" id="playBtn_1"><i class="fa-solid fa-play" aria-hidden="true"></i><span class="sr-only">Play Video</span></button>'+
          ' <button class="video-controls" id="pauseBtn_1"><i class="fa-solid fa-pause" aira-hidden="true"></i><span class="sr-only">Pause Video</span></button>'+
          ' <button class="video-controls" id="stopBtn_1"><i class="fa-solid fa-stop" aria-hidden="true"></i><span class="sr-only">Stop Video</span></button>'+
          '</div></div>';
        var transcript_wrapper_1 = '<div class="video-transcript-1"><details class="trans">'+
	        '<summary class="transBtn">Transcript <span class="icon"><i aria-hidden="true" class="fa-regular fa-angle-up"></i></span></summary>'+
	        ' <div class="transCntntWrap">'+
		      '   <div class="h5" role="heading" aria-level="3">Descriptive Video Transcript</div>'+          
          '   <h4 class="h5">Video: NESTOUT</h4>'+
          '   <p>[Video Start]<br>[English]</p>'+
          '   <p>Video showing rugged power banks, lights, solar panel, and accessories used outdoors in real-life adventures.</p>'+
          '   <p>[Video End]</p>'+
	        ' </div>'+
          '</details>';
        //set asset file 
        const vttUrl = "//nestout.com/cdn/shop/t/47/assets/HomePage-Nestout-Video.vtt?v=126818844906992219461784234692";
        var count = 0;
        jQuery('video').each(function(){
          console.log('Video found');          
          var curSource = String($(this).find('source').attr('src'));
          var curAria = String($(this).attr('aria-label'));
          console.log('current video aria: '+curAria+' cur source: '+curSource);
         
          if(count === 0){
            jQuery(this).append('<track default="" kind="captions" srclang="en" label="English" src="'+vttUrl+'">');
            jQuery(this).attr('controls','controls');
            jQuery(this).attr('id','homepage_video');
            console.log('desktop video updated');
            count++;
          } else if(count === 1){
            jQuery(this).append('<track default="" kind="captions" srclang="en" label="English" src="'+vttUrl+'">');
            jQuery(this).attr('controls','controls');
            jQuery(this).attr('id','homepage_video_mobile');
            console.log('mobile video updated');
            count++;
          }
          
        });

        //video controls but they must be outside the link wrapper of the video
        jQuery('.shopify-section').each(function(){
          if($(this).find('#homepage_video').length > 0){
            $(this).append(custom_controls_1);
            $(this).append(transcript_wrapper_1);
            $(this).find('a[tabindex="-1"]').each(function(){
              $(this).attr('tabindex','0').attr('aria-label','Link to all Collections');
            });
          }
        });
        /*jQuery('#shopify-section-template--20177514037400__video_with_text_overlay_FTqEL9').append(custom_controls_1);
        jQuery('#shopify-section-template--20177514037400__video_with_text_overlay_FTqEL9').append(transcript_wrapper_1);
        jQuery('#shopify-section-template--20177514037400__video_with_text_overlay_FTqEL9').find('a[tabindex="-1"]').each(function(){
          jQuery(this).attr('tabindex','0');
        });*/

        setTimeout(function(){
          if($('#homepage_video').length > 0){
            videoControls();
          }
          
          jQuery('#shopify-section-template--18854502039704__video_with_text_overlay_FTqEL9').find('.video-container-1').each(function(){
            jQuery(this).find('button').on('keydown', function(e){
              if(e.key === 'Enter'){
                jQuery(this).click();
              }
            });
          });
          jQuery('#shopify-section-template--18854502039704__video_with_text_overlay_FTqEL9').find('.video-transcript-1').each(function(){
            jQuery(this).find('summary').on('keydown', function(e){
              if(e.key === 'Enter'){
                jQuery(this).click();
              }
            });
          });
        },1200);
        },3000);

        //sale price - original pricing
        jQuery('.sale-price').each(function(){
          jQuery(this).attr('title','Sale Price');
        });
        jQuery('.regular-price').each(function(){
          jQuery(this).attr('title','Regular Price');
        });

    },1000);   

     
    
  function ariaCleanup() {
    $('[aria-haspopup]').removeAttr('aria-haspopup');
		$('[aria-pressed]').removeAttr('aria-pressed');
    $('[data-acsb="skipLinks"]').each(function(){
      jQuery(this).removeAttr('aria-hidden');
      jQuery(this).attr('role','navigation').attr('aria-label','By Pass Links');
      jQuery(this).find('[aria-hidden]').each(function(){
        jQuery(this).removeAttr('aria-hidden');
      });
    });
  }
  ariaCleanup();
	
      

      

     

      //color swatches
      setTimeout(function(){
      $('.color-swatch-selector').each(function(){
        $(this).find('label').each(function(){
          var curFor = String($(this).attr('for'));
          var curLblTitle = String($(this).attr('title'));
          if(!curFor || curFor === '' || curFor === 'undefined'){
          }else{
            if(!curLblTitle || curLblTitle === '' || curLblTitle === 'undefined'){
              curLblTitle = 'Color Variant';
            }
            $('#'+curFor).attr('aria-label',curLblTitle);
          }
        });
      });
      },1800);

      //video link for all collections page
      $('a.section.section--full-width.bg-transparent').attr('aria-label','video background | link to "all products" collections page');
      
      setTimeout(function(){
       //duplicate instagram wraps and feeds id="1-insta-feed"
       /* var instaFeedCnt = 0;
        $('.instafeed-modals-wrapper').each(function(){
          if(instaFeedCnt > 0){
           //$(this).remove();
          }
          instaFeedCnt++;
        });*/
        var itemCnt = 0;
        $('#insta-feed').find('.instafeed-new-layout-item').each(function(){
          $(this).attr('data-id-cnt',itemCnt);
          itemCnt++;
        });

      },1800);

      // thumbnail images
      setTimeout(function(){
        $('.product-thumbnail').each(function(){
          var curAlt = String($(this).find('img').attr('alt'));
          if(!curAlt || curAlt === '' || curAlt === 'undefined'){
          } else {
          $(this).attr('aria-label', 'Go to Product: '+curAlt);
          }
        });
        $('#shopify-installments-cta').attr('tabindex','0');
      },1800);

      //notify of quantity increase/decrease
      var alertQtyMsg = '<div id="QtyAlert" role="alert">';
      var alertMsg = '';
      var alertQtyMsgCls = '</div>';
      $('.qty-selector__button').each(function(){
        $(this).on('click', function(){
          var curAria = String($(this).attr('aria-label'));
          var curInputId = String($(this).parent().find('[name="quantity"]').attr('id'));
          const qtyInput = document.getElementById(curInputId);
          const qtyValue = qtyInput.value;          
          if(curAria.indexOf('Increase') > -1){
            alertMsg = '<p class="alertQty">You have increased the Quantity.<br /> Your current quantity is '+qtyValue+'.</p>';
          } else {
            if(qtyValue === '1'){
            alertMsg = '<p class="alertQty">You have decreased the Quantity.<br /> Your current quantity has returned to the value of '+qtyValue+'.</p>';
            }else{
            alertMsg = '<p class="alertQty">You have decreased the Quantity.<br /> Your current quantity is '+qtyValue+'.</p>';
            }            
          }
          if($('#QtyAlert').length > 0){
            $('#QtyAlert').html(alertMsg);
          } else {
            $(this).parent().parent().append(alertQtyMsg + alertMsg + alertQtyMsgCls);
          }          
        });
      });

      //product description
      $('.section-main-product-details').each(function(){
        $(this).find('summary .product-info-heading').attr('role','heading').attr('aria-level','2');
        $(this).find('h2').each(function(){
          $(this).attr('aria-level','3');
        });
      });
      //product upsell issues continued
      function upSellUpdates(){
        if($('[data-essential-upsell-element]').length > 0){
          $('[data-essential-upsell-element="container"').each(function(){
            $(this).find('[data-essential-upsell-element="header"]').attr('role','heading').attr('aria-level','2');
            $(this).find('input[type="checkbox"]').each(function(){
              var curTitle = String($(this).parent().parent().find('[data-essential-upsell-element="title"]').text());
              $(this).parent().parent().find('[data-essential-upsell-element="title"]').parent().attr('role','heading').attr('aria-level','3');
              $(this).attr('aria-label','Checkbox for: '+curTitle);
            });
          });
        }
      }
      setTimeout(function(){
        upSellUpdates();
      },2200);

/* =========================================================
                      Mutation Observer
   ======================================================= */
   function dynamicUpdates(){
    if($('#UpcartPopup').length > 0){
      $('.pw-route-protection').attr('role','note');
      $('.upcart-checkout-button').attr('role','button');
      $('.pw-button-reset').removeAttr('aira-haspopup');
      $('#UpcartPopup').attr('aria-label','cart').attr('role','alertdialog');
      $('#UpcartPopup').find('#CartPopup').attr('role','document').attr('tabindex','0');
      $('#UpcartPopup').find('#CartPopup').find('.upcart-header-text').attr('id','cartTitle').prepend('<span class="sr-only">Shopping Cart - </span>');
      $('#UpcartPopup').find('#CartPopup').find('.upcart-cart-body').attr('id','cartBody');
      $('#UpcartPopup').find('#CartPopup').find('.upcart-products-section').each(function(){
        //set all svg's to aria-hidden
        $(this).find('svg').each(function(){
          $(this).attr('aria-hidden','true');
        });        
        $(this).attr('id','CurrentProducts');
        var curPrdTitle = '';
        var curPrdRow = 1;
        var curCInputId = 'cartItm_';
        $(this).find('.upcart-product-item').each(function(){
          $(this).addClass('ep-Row').attr('ep-row-num',curPrdRow);
          curPrdTitle = String($(this).find('.upcart-product-title-link').text());
          curPrdTitle = $.trim(curPrdTitle);
          $(this).attr('ep-prd-name',curPrdTitle);
          //delete button needs markup
          $(this).find('.styles_TrashButton__deleteButton__').attr('role','button').attr('aria-label','Delete "'+curPrdTitle+'" from cart.').attr('tabindex','0');
          $(this).find('.styles_QuantityField__').each(function(){
            $(this).addClass('ep-Qty');
            curCInputId = curCInputId+curPrdRow;
            $(this).find('input[type="number"]').each(function(){
              $(this).attr('id',curCInputId);
              //console.log("Cart Product Qty Input Id Updated for "+curPrdTitle);
            });
            $(this).find('button').each(function(){
              $(this).addClass('ep-Qty-Btn');
              if($(this).hasClass('upcart-product-quantity-minus')){
                $(this).attr('ep-dir','down');
              } else {
                $(this).attr('ep-dir','up');
              }
            });
          });
          //counter
          curPrdRow++;
        });
        
        
      });    
        
    }
   }
   dynamicUpdates();
   //this was disabled when cart was set as shadow dom - removing to allow cart to scroll
   setTimeout(function(){
   $('#UpcartPopup').find('#upcart-express-pay-buttons-container').remove();
   },1200);

   function CartOpenAlert(){
    var cartOpenNotification = '<div role="alert" class="sr-only">Cart Slideout is Open</div>';
    setTimeout(function(){
      if($('#UpcartPopup').hasClass('upcartPopupShow')){
        $('#UpcartPopup').find('.upcart-header').parent().append(cartOpenNotification);
      } else {
        
      }
      },1800);
   }
   //menu icon cart pressed
   $('.header-icon-btn').each(function(){
    var curTg = String($(this).attr('href'));
    $(this).on('click', function(){
      if(curTg.indexOf('/cart') > -1){
        CartOpenAlert();
      }
    });
   });
   //Add to cart button from sliders
   $('button[aria-label="Add to cart"]').each(function(){    
    $(this).on('click', function(){      
      CartOpenAlert();      
    });
   });
   //Add to cart button from Quick Add modal
   $('.button-add-to-cart').each(function(){    
    $(this).on('click', function(){      
      CartOpenAlert();      
    });
   });

   //CartOpenAlert();

   
  //notify of quantity increase/decrease 
      //cart and cart notifications
      //notify of quantity increase/decrease
      var cartAlertQtyMsg = '<div id="CartAlert" role="alert">';
      var cartAlertMsg = '';
      var cartAlertQtyMsgCls = '</div>';
      $('#CartPopup').find('.upcart-products-section').each(function(){        
        $(this).find('.upcart-product-item').each(function(){
          var curProductName = String($(this).attr('ep-prd-name'));
          //console.log('product title: '+curProductName); 
          $(this).find('.styles_TrashButton__deleteButton__').on('click',function(){
            setTimeout(function(){
              dynamicUpdates();
            }, 1200);
            setTimeout(function(){  
              cartAlertMsg = '<p class="alertQty del">Item Deleted from cart:<br /> '+curProductName+'.</p>';
              if($('#CartAlert').length > 0){
                $('#CartAlert').html(cartAlertMsg);
              } else {
                $('#UpcartPopup').find('.upcart-header').parent().prepend(cartAlertQtyMsg + cartAlertMsg + cartAlertQtyMsgCls);
              }    
            },1500); 
          });        
          $(this).find('.styles_QuantityField__').each(function(){            
            $(this).find('button').each(function(){             
              $(this).on('click', function(){
                //var curClass = String($(this).attr('class'));
                //console.log('Cart Qty Button clicked for '+curProductName);
                setTimeout(function(){
                  dynamicUpdates();
                }, 1200);
                setTimeout(function(){    
                cartAlertMsg = '<p class="alertQty">You have changed the Quantity for:<br /> '+curProductName+'.</p>';
                if($('#CartAlert').length > 0){
                  $('#CartAlert').html(cartAlertMsg);
                } else {
                  $('#UpcartPopup').find('.upcart-header').parent().prepend(cartAlertQtyMsg + cartAlertMsg + cartAlertQtyMsgCls);
                }    
                },1500);      
              });
            });
          });     
        });
      });

 //scrolling logos needs to have tabindex
 $('.ai-awards-logos-wrapper-asm15nxpwv3rlwmtenaigenblock793bffa3pdfqf').attr('tabindex','0');

//keyboard trap for email modal
function needsClickPopup(){
  var dogs;
  if($('div[role="dialog"].needsclick').length > 0){
    $('div[role="dialog"].needsclick').attr('id','signup_modal');
    dogs = document.querySelector('#signup_modal');
    keyboardNav('#signup_modal',dogs);
  }
}

needsClickPopup();
// MutationObserver (instead of setInterval)
 // const observer = new MutationObserver(needsClickPopup);
 // observer.observe(document.body, { childList: true, subtree: true });

 $('a[href]').each(function(){
  var curHtml = String($(this).html());
  if(curHtml.indexOf('<img') > -1){
    $(this).addClass('img-link');
  }
 });


      //fighting IACS
      setTimeout(function(){
       
      //fix summary/details sort 
      jQuery('.collection-grid__sort').each(function(){
        jQuery(this).find('summary').each(function(){
          jQuery(this).find('button').each(function(){
            var curText = String(jQuery(this).text());
            jQuery(this).attr('role','region').attr('aria-label',jQuery.trim(curText)).removeAttr('aria-hidden');
          });
        });
      });
      jQuery('details').each(function(){
        var curTxt = '';
        jQuery(this).find('summary').each(function(){
            jQuery(this).find('.menu-item').each(function(){                
                 curTxt = String(jQuery(this).text());
            });
            curTxt = jQuery.trim(curTxt);
            if(curTxt !== ''){
              jQuery(this).attr('aria-label',curTxt);
            }
          });
      });
      //fix tablist
        jQuery('ul[role="tablist"]').each(function(){
          jQuery(this).find('li').each(function(){
            jQuery(this).attr('role','tab');
            jQuery(this).find('a[role="tab"]').each(function(){
              jQuery(this).removeAttr('role');
            });
          });
        });
        jQuery('[for="scoreDropdownInput"]').each(function(){
          jQuery(this).css('margin-top','-35px');
          jQuery(this).removeAttr('data-acsb-force-visible');
        });
        jQuery('input').each(function(){
          //do not change roles on inputs
          jQuery(this).removeAttr('role');
        });
        var revPnlCnt = 1;
        jQuery('.yotpo-main-reviews-widget').each(function(){
          jQuery(this).attr('aria-label','Review Panel #'+revPnlCnt).removeAttr('aria-labelledby');
          revPnlCnt++;
        });
         jQuery('media-carousel').each(function(){
            jQuery(this).attr('tabindex','0');
        });
        jQuery('.scroll-area-x').each(function(){
            jQuery(this).attr('tabindex','0');
        });
      },2000);

       //video controls
    function videoControls(){    
      const video = document.getElementById('homepage_video');
      const playBtn = document.getElementById('playBtn_1');
      const pauseBtn = document.getElementById('pauseBtn_1');
      const stopBtn = document.getElementById('stopBtn_1');

      playBtn.addEventListener('click', () => {
        video.play();
      });

      pauseBtn.addEventListener('click', () => {
        video.pause();
      });

      stopBtn.addEventListener('click', () => {
        video.pause();
        video.currentTime = 0; // Reset video to the beginning
      });
    } //end videoControls()

    /* Keyboard Trap for Popups */
    /**
     * - Focus correct Element
     * - Trap focus,
     * - Focus the correct Element
     * @param config {
     *	el: HtmlElement. The Parent Element, within which focus should be tracked
    * }
    * @param container {
    *	querySelector for parent config
    * }
    */
    function keyboardNav(config, container) {
        if (!config) {
            throw new Error('Could not initialize focus - Config Missing');
        }
        /* Constants */
        var KEY_CODE_MAP = {
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27
        };
        var FOCUSABLE_ELEMENT_SELECTORS = 'area[href], input:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="email"]:not([disabled]), input[type="tel"]:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href]:not([disabled]):not(.disabled), [tabindex]';
        var el = container,
            escCallback = config.escCallback,
            focusElement = config.focusElement;
        if (!el) {
            throw new Error('Could not initialize focus - Element Missing: ' + JSON.stringify(config));
        }
        if (escCallback && !(escCallback instanceof Function)) {
            throw new Error('Could not initialize initial focus - `config.escCallback` is not a function');
        }
        var focusableElements = el.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
        var keyboardHandler;

        /* Nav Menus contain focusable Elmements and possibly dropdown elements */
        if (focusableElements.length > 0) {
            var firstFocusableEl = focusableElements[0],
                lastFocusableEl = focusableElements[focusableElements.length - 1],
                elementToFocus = focusElement ? focusElement : firstFocusableEl;

            elementToFocus.focus();

            keyboardHandler = function keyboardHandler(e) {
                if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
                    e.preventDefault();
                    jQuery(config).find('.lion-notification__close-button').each(function(){
											jQuery(this).click();
									  	setTimeout(function(){				
				  					 		jQuery('#main-content').focus();
											}, 1200);
										});
									//.pxl-menu-close
										jQuery(config).find('.pxl-menu-close').each(function(){
											jQuery(this).click();
									  	setTimeout(function(){				
				  					 		jQuery('.pxl-nav-mobile-button').focus();
											}, 1200);
										});
									  
											
                }
                if (e.KeyCode === KEY_CODE_MAP.ENTER) {

                }
                if (e.keyCode === KEY_CODE_MAP.TAB) {
                    //Rotate Focus
                    if (e.shiftKey && document.activeElement === firstFocusableEl) {
                        e.preventDefault();
                        lastFocusableEl.focus();
                    } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
                        e.preventDefault();
                        firstFocusableEl.focus();
                    }
                }
            };/* End KeyboardHandler */
            el.addEventListener('keydown', keyboardHandler);
        }/* End focusableElements > 0 */
        //The cleanup function. Put future cleanup tasks inside this.
        return function cleanUp() {
            if (keyboardHandler) {
                el.removeEventListener('keydown', keyboardHandler);
            }
        }; /* End Cleanup */
    }/* End keyboard trap function*/

});